// This is a fix for a chrome issue:
// when multiple videos are loaded in the same page, if the
// user clicks on the controls (3 dots button), the floating
// menu always appear in the last video.
if(/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
  $(document).ready(function() {
    $(document).on('DOMNodeInserted', function(e) {
      $('video').removeAttr('controls')
    });

    $(document).on('mouseenter','video', function(e) {
      e.target.controls = true
    });

    $(document).on('mouseleave','video', function(e) {
      e.target.controls = false
    });
  })
}